/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// document.addEventListener('DOMContentLoaded', function() {
//     let videoElem = document.querySelector(".video-container video");
//     let playButton = document.querySelector(".js-video-play ");

//     playButton.addEventListener("click", handlePlayButton, false);
//     // playVideo();

//     async function playVideo() {
//         try {
//             await videoElem.play();
//             videoElem.setAttribute("controls", "controls");  // Dodajemy kontrolki po odtworzeniu
//             playButton.classList.add("playing");
//         } catch (err) {
//             playButton.classList.remove("playing");
//         }
//     }

//     function handlePlayButton() {
//         if (videoElem.paused) {
//             playVideo();
//             playButton.classList.add("d-none");
//         } else {
//             videoElem.pause();
//             videoElem.removeAttribute("controls");  // Usuwamy kontrolki po zatrzymaniu
//             playButton.classList.remove("playing");
//         }
//     }
// });

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-video-wrapper').forEach((wrapper) => {
        const video = wrapper.querySelector('video');
        const playButton = wrapper.querySelector('.custom-play-button');

        playButton.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playButton.textContent = '⏸';
            } else {
                video.pause();
                playButton.textContent = '▶';
            }
        });
    });
});


/* eslint-enable no-console */
